import api from './api';

export const profilePhotoService = {
  // Upload profile photo
  async uploadProfilePhoto(itemId, file) {
    const formData = new FormData();
    formData.append('file', file);
    // Let Axios set multipart boundary automatically
    const response = await api.post(`/items/${itemId}/profile-photo`, formData);
    return response.data;
  },

  // Get profile photo as blob (direct download)
  async getProfilePhotoBlob(itemId) {
    try {
      const response = await api.get(`/items/${itemId}/profile-photo/download`, {
        responseType: 'blob',
      });
      // Create blob URL from response
      const url = URL.createObjectURL(response.data);
      return { url, blob: response.data };
    } catch (e) {
      throw e;
    }
  },

  // Get profile photo URL (presigned - fallback)
  async getProfilePhotoUrl(itemId) {
    const response = await api.get(`/items/${itemId}/profile-photo`);
    return response.data;
  },

  // Delete profile photo
  async deleteProfilePhoto(itemId) {
    const response = await api.delete(`/items/${itemId}/profile-photo`);
    return response.data;
  },
};
